import React, { HTMLAttributes } from 'react';
import ReactDOM from 'react-dom';

import { Container, Content } from './styles';

type DrawerProps = HTMLAttributes<HTMLDivElement> & {
  containerStyle?: React.CSSProperties;
  isVisible?: boolean;
  animated?: boolean;
};

const Drawer: React.FC<DrawerProps> = ({
  animated = true,
  children,
  isVisible,
  containerStyle,
  ...rest
}) => {
  return ReactDOM.createPortal(
    <Container
      className={isVisible ? 'visible' : 'hidden'}
      animated={animated}
      style={{
        ...containerStyle,
        opacity: typeof isVisible === 'undefined' ? 0 : 1,
      }}
    >
      <Content {...rest}>{children}</Content>
    </Container>,
    document.body,
  );
};

export default Drawer;
